// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
export default function stripDiacritics(string: string) {
	return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string
}